module.exports = __webpack_public_path__ + "img/used_for_advertising.fd95ffcd.webp";